import { render, staticRenderFns } from "./BetSlipTab.vue?vue&type=template&id=736ec7e4&"
import script from "./BetSlipTab.vue?vue&type=script&lang=js&"
export * from "./BetSlipTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports